export enum DeviceType {
  Default = 1,
  BackOffice = 2,
  Whiteboard = 3,
  TheatreWaiting = 4,
  TheatreOperatingRoom = 5,
  TheatreRecovery = 6,
  EmergencyCupboard = 7,
  Pharmacy = 8,
  TisScoring = 9,
  TheatreBackOffice = 10,
}
